import { Component, OnInit } from "@angular/core";
import { AccountService } from "../../../main/services";
import { UserInforService } from "../../../main/services/user-infor.service";
import { catchError, of, tap } from "rxjs";

@Component({
  selector: "app-sidebar-header",
  templateUrl: "./app-sidebar-header.component.html",
  styleUrls: ["./app-sidebar-header.component.scss"],
})
export class AppSidebarHeaderComponent implements OnInit {
  toggleIcon = true;
  userInfor!: any;
  constructor(
    private readonly accountService: AccountService,
    private readonly userInfoService: UserInforService
  ) {}

  ngOnInit() {
    this.getUserInfor();
  }

  getUserInfor() {
    this.accountService
      .getUserInfor()
      .pipe(
        tap((value: any) => {
          const result = value?.result;
          if (value) {
            this.userInfoService.setUserInfo(result);
            this.userInfor = result;
          }
        }),
        catchError((error) => {
          console.error("Error fetching user info:", error);
          return of(null);
        })
      )
      .subscribe();
  }

  onClickMe() {
    this.toggleIcon = !this.toggleIcon;
  }
}
